/**
 * Token de acceso del navegador.
 * · Administrador General: «mantener sesión» (localStorage, sobrevive al cerrar el navegador).
 * · Demás perfiles: solo la sesión del navegador (sessionStorage); además el servidor vence la sesión por
 *   inactividad y por duración máxima. Que el navegador no guarde la contraseña depende de equipos administrados.
 */
const K = "agroport_token";

export function getToken() {
  try { return sessionStorage.getItem(K) || localStorage.getItem(K); } catch { return null; }
}

export function setToken(token, persistente) {
  try {
    clearToken();
    (persistente ? localStorage : sessionStorage).setItem(K, token);
  } catch { /* almacenamiento no disponible */ }
}

export function clearToken() {
  try { sessionStorage.removeItem(K); localStorage.removeItem(K); } catch { /* sin almacenamiento */ }
}
